import type { CellConfig } from "@topi/shared/cell/cell-config";

export const cellConfig: CellConfig = {
  websiteBase: "https://www.topi.eu",
  topiPortal: "https://rentwith.us.topi.eu/",
  emails: {
    support: "support@topi.eu",
    sales: "sales@topi.eu",
    emergencyContact: "offer@topi.eu",
  },
  imprint: null,
  faqs: {
    en: "https://www.topi.eu/en/faqs",
  },
  renters: {
    en: "https://www.topi.eu/en/rent",
  },
  showsTrustpilot: false,
};
